/**
 * Compares two semantic versions.
 * @param versionA The version A to compare.
 * @param versionB The version B to compare against.
 */
function compareSemVer(versionA, versionB) {
  validateSemVer(versionA);
  validateSemVer(versionB);
  return versionA.localeCompare(versionB, undefined, {
    numeric: true
  });
}
/**
 * Checks that the string conforms to the format of a semantic version number.
 * @param version The version.
 */
function validateSemVer(version) {
  if (version.split('.').length !== 3) {
    throw Error(`The version '${version}' must be in the format 'x.x.x'.`);
  }
}

export { compareSemVer };
//# sourceMappingURL=index.es.js.map
